import { Tooltip } from '@flowus/common/components/tooltip';
import { cx } from '@flowus/common/cx';
import { keys } from 'lodash-es';
import { memo, useEffect } from 'react';
import { formatSpecificTimestamp, formatTimestamp } from 'src/common/utils/formatter';
import { useOpenPage } from 'src/hooks/page/use-open-page';
import { $taskState, deleteDoneTaskByState, refreshTaskFromState } from 'src/utils/tasks';

export const TaskListPanel = memo(() => {
  const openPage = useOpenPage();

  const tasks = $taskState((state) => {
    return keys(state)
      .map((key) => ({ taskId: key, ...state[key] }))
      .sort((i) => i.startTime!);
  });

  useEffect(() => {
    refreshTaskFromState();
  }, []);

  return (
    <div className="space-y-2.5 py-2.5">
      <div className="text-t1-bold">导入任务列表</div>
      {tasks.map((item) => {
        const result = {
          title: '',
          status: item.resData?.result?.status || item.resData?.status,
          msg: item.resData?.result?.msg,
          startTime: item.startTime,
          lastTime: item.lastTime,
        };

        const isNotion = item.body?.request.importOptions?.type === 'notion';
        if (isNotion && item.body?.request.importOptions?.notionId) {
          result.title = item.body.request.importOptions.notionId;
        } else if (item.body?.request.blockId) {
          result.title = item.body?.request.blockId;
        }

        const isFail = result.status === 'fail';
        const pageId = item.resData?.result?.uuid;
        const isDone = result.status === 'success' && item.resData?.result?.uuid;
        const isProgress = item.resData?.status === 'in_progress';
        const showOption = isFail || isDone;

        return (
          <Tooltip
            key={item.taskId}
            placement="top-end"
            offset={[0, 2]}
            interactive
            theme="next-modal"
            popup={
              showOption && (
                <div className="grid grid-cols-2 space-x-2">
                  <span
                    className="animate-click"
                    onClick={() => {
                      pageId && openPage(pageId, { forceOpenNewTab: true });
                    }}
                  >
                    打开
                  </span>
                  <span
                    className="animate-click"
                    onClick={() => deleteDoneTaskByState(item.taskId)}
                  >
                    删除
                  </span>
                </div>
              )
            }
            className={cx(
              'text-t3 rounded p-2 block cursor-default',
              isDone && 'bg-green/10',
              isFail && 'bg-red/10',
              isProgress && 'bg-grey9 animate-pulse'
            )}
          >
            <div className="text-t2">ID: {result.title}</div>
            <div>
              {[
                {
                  title: '开始时间',
                  value: result.startTime && formatTimestamp(result.startTime),
                },
                {
                  title: '追踪任务状态',
                  value: result.lastTime && formatSpecificTimestamp(result.lastTime),
                },
                {
                  title: '导入',
                  value: item.body?.request.importOptions?.type,
                },
                {
                  title: '状态',
                  value: result.status,
                },
                {
                  title: '提示',
                  value: result.msg,
                },
              ]
                .filter((d) => d.value)
                .map((desc) => (
                  <div className="space-x-1" key={desc.title}>
                    <span>{desc.title}</span>
                    <span className="text-grey3">{desc.value}</span>
                  </div>
                ))}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
});
